/* eslint-disable react/jsx-no-bind */
import React from 'react'
import { connect } from 'react-redux'
import xtend from 'xtend'

import {
    DropdownButton,
    MenuItem,
    Modal
} from 'react-bootstrap'

import {
    FaPlus,
    FaYoutubePlay,
    FaTwitch,
    FaTwitter,
    FaFacebookOfficial,
    FaTrashO,
    FaCircle
} from 'react-icons/lib/fa'

import { MdSave } from 'react-icons/lib/md'

// import WowzaLogo from '../../../../../lib/components/icons/WowzaLogo'

import Loader from '../../../../../common/components/notifications/Loader'
import HelpCollection from './help'

import EditStreamTarget from './EditStreamTarget'
import RestrictedComponent from '../../../../../lib/components/form/RestrictedComponent'
import { getHasRequestPending } from '../../../../../redux/data/selectors'
import schema from '../../../../../routes/permissions/schema'


// Finds Hyphens
const HyphenRegex = new RegExp(/-/g)

// Maximum allowed Alt Destinations per Event
const MAX_STREAMS = 6



function getIcon (name) {
    switch (name) {
        case 'YouTube':
            return <FaYoutubePlay/>
        case 'Twitter-Periscope':
            return <FaTwitter/>
        case 'Facebook-Live':
            return <FaFacebookOfficial/>
        case 'Twitch':
            return <FaTwitch/>
        case 'Wowza':
            break;
            // return <WowzaLogo/>
    }
}

function getName (name) {
    let icon = getIcon(name)

    return <span
        className={['header-type', name.toLowerCase()].join(' ')}>
        {icon} {name.replace(HyphenRegex, ' ')}
    </span>
}

const PendingTarget = props => {
    return <div className="target target__pending">
        <div className="panel panel-default">
            <div className="panel-heading">
                <h3 className="panel-title">
                    {getName(props.altProviderName)}
                    <span className="header-label">Create Social Stream</span>
                </h3>
            </div>
            <div className="panel-body">
                {props.children}
            </div>
            <div className="panel-footer">
                <button className="btn btn-link"
                    onClick={props.cancel}>
                    Cancel
                </button>
                <button className="btn btn-success"
                    onClick={props.submit}>
                    <MdSave/> Add Social Stream to Event
                </button>
            </div>
        </div>
    </div>
}

const AltDestination = props => {
    let { destination, eventStatus } = props
    let altProviderName = destination.altProviderName

    let status = destination.isTransmitting ? "online" : "offline";

    let NameLabel = (destination.destName !== '') ? <div>
        <label>{destination.destName}</label>
    </div> : '';

    return <div className="target target__existing">
        <div className="panel panel-default">
            <div className="panel-body">
                {NameLabel}
                <header>
                    <div className={['target__icon', altProviderName.toLowerCase()].join(' ')}>
                        {getIcon(altProviderName)}
                    </div>
                    <div className="target__name">{altProviderName.replace(HyphenRegex, ' ')}</div>
                    <div className={'target__status status__' + status}>
                        <small><FaCircle/> {status}</small>
                    </div>
                </header>
                <hr/>
                <div style={{ margin: '2rem 0'}}>

                    <div>
                        <label>Server Url:</label>
                        <pre>{destination.serverUrl}</pre>
                    </div>
                    <div>
                        <label>Server Key:</label>
                        <pre>{destination.key}</pre>
                    </div>

                </div>
            </div>
            <div className="panel-footer">
                <RestrictedComponent permissionCheck={schema.EVENT_TAB_SOCIAL.UPDATE}>
                    <button className="btn btn-link"
                        onClick={props.edit.bind(null, destination)}>
                            Edit
                    </button>
                </RestrictedComponent>
                <RestrictedComponent permissionCheck={schema.EVENT_TAB_SOCIAL.DELETE}>
                    <button className="btn btn-danger"
                        onClick={props.remove}>
                        <FaTrashO/> Remove Social Stream
                    </button>
                </RestrictedComponent>
            </div>
        </div>
    </div>
}


class Wrapper extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            validators: [],
            editMode: false,
            confirmDeleteModal: false
        }

        this.serverUrlRef = React.createRef()
        this.streamKeyRef = React.createRef()
        this.destNameRef = React.createRef()
        this.userRef = React.createRef()
        this.passwordRef = React.createRef()

        this.toggleTargetEdit = this.toggleTargetEdit.bind(this)
        this.toggleConfirmDelete = this.toggleConfirmDelete.bind(this)

        this.submit = this.submit.bind(this)
        this.renderPendingTargetInputs = this.renderPendingTargetInputs.bind(this)
    }

    componentWillMount () {
        this.props.actions.streamTargets.getAltProviders()
        this.props.actions.streamTargets.getAltDestinations({
            'eventID': this.props.event.eventID
        })
    }

    // @TODO: Reset the Alt Destination data when leavning
    // componentWillUnmount () {
    //     this.props.actions.streamTargets.resetStoreData()
    // }

    shouldComponentUpdate (nextProps, nextState) {
        return (
            // this.props.event != nextProps.event ||
            this.state != nextState ||
            this.props.streamTargets != nextProps.streamTargets ||
            this.props.streamTargetView != nextProps.streamTargetView ||
            this.props.eventTargetDestinations != nextProps.eventTargetDestinations ||
            this.props.isResolving != nextProps.isResolving
        )
    }

    toggleTargetEdit (destination) {
        this.setState({
            editMode: !destination ? false : destination
        })
    }

    toggleConfirmDelete () {
        this.setState({
            confirmDeleteModal: !this.state.confirmDeleteModal
        })
    }

    submit (ev, data) {
        ev && ev.preventDefault()

        if (data) {
            let payload = xtend({
                clientID: this.props.clientID,
                eventID: this.props.event.eventID
            }, data)
            this.setState(() => ({ editMode: false, validators: [] }))
            this.props.actions.streamTargets.edit(payload)
        } else {


            let { altProviderName } = this.props.streamTargetView.pending

            let {
                serverUrlRef,
                streamKeyRef,
                destNameRef,
                userRef,
                passwordRef
            } = this
            let invalid = []

            let serverUrl = serverUrlRef.current.value,
                streamKey = streamKeyRef.current.value,
                destName = destNameRef.current.value,
                userName, password

            if (!serverUrl) invalid.push('serverUrl')
            if (!streamKey) invalid.push('streamKey')

            if (altProviderName == 'Wowza') {

                userName = userRef.current.value
                password = passwordRef.current.value

                if (!userName) invalid.push('userName')
                if (!password) invalid.push('password')
            }

            if (invalid.length) {
                this.setState({ validators: invalid })
            } else {
                let payload = {
                    clientID: this.props.clientID,
                    eventID: this.props.event.eventID,
                    provider: altProviderName,
                    serverUrl: serverUrl,
                    key: streamKey,
                    destName: destName
                }
                if (altProviderName == 'Wowza') {
                    payload = xtend(payload, {
                        userName: userName,
                        password: password
                    })
                }

                this.setState(() => ({ editMode: false, validators: [] }))
                this.props.actions.streamTargets.add(payload)
            }
        }
    }

    render () {
        const self = this
        let { streamTargets, eventTargetDestinations, streamTargetView, isResolving } = this.props

        if (
            streamTargets.isResolving ||
            !eventTargetDestinations ||
            isResolving
        ) return <Loader message="Fetching Available Social Streams"/>

        if (eventTargetDestinations.hasOwnProperty(this.props.activeEvent)) {
            eventTargetDestinations = eventTargetDestinations[this.props.activeEvent]
        } else {
            eventTargetDestinations = []
        }

        // Takes the Name of the target and uses the like-named component
        // exported from the HelpCollection
        let HelpContent = (streamTargetView.pending !== false) ?
            HelpCollection[
                streamTargetView.pending.altProviderName
            ] || HelpCollection.default : null

        let inputs = [{
            name: 'destName',
            label: 'Label',
            ref: this.destNameRef,
            optional: true,
            placeholderText: "Friendly name (optional)"
        },{
            name: 'serverUrl',
            label: 'Server URL',
            ref: this.serverUrlRef,
            optional: false,
            placeholderText: "Provider Server URL (required)"
        }, {
            name: 'streamKey',
            label: 'Stream Key',
            ref: this.streamKeyRef,
            optional: false,
            placeholderText: "Provider Stream Key/name (required)"
        }]

        if (streamTargetView.pending.altProviderName == 'Wowza') {
            Array.prototype.push.apply(inputs, [{
                name: 'userName',
                label: 'User Name',
                ref: this.userRef,
                optional: false,
                placeholderText: "User Name (required)"
            }, {
                name: 'password',
                label: 'Password',
                ref: this.passwordRef,
                optional: false,
                placeholderText: "Password (required)"
            }])
        }

        return <div id="stream-targets">

            {this.state.editMode !== false ?
                <EditStreamTarget
                    {...this.state.editMode}
                    editMode={this.state.editMode}
                    streamKey={this.state.editMode.key}
                    cancel={this.toggleTargetEdit}
                    submit={this.submit}/> :
                null}

            <header id="create-controls">
                <RestrictedComponent permissionCheck={schema.EVENT_TAB_SOCIAL.CREATE}>
                    <DropdownButton bsStyle="primary"
                        disabled={eventTargetDestinations.length === MAX_STREAMS}
                        noCaret
                        title={<div>Add Destination <FaPlus/></div>}
                        id="stream-target-select-dd"
                    >
                        {streamTargets.data.map((target, index) => {
                            return <MenuItem key={index}
                                onClick={ev => {
                                    ev && ev.preventDefault()
                                    this.props.actions.streamTargets.addPending(target)
                                }}
                            >
                                {target.altProviderName.replace(HyphenRegex, ' ')}
                            </MenuItem>
                        })}
                    </DropdownButton>
                </RestrictedComponent>
                <div id="remaining">
                    <strong>{MAX_STREAMS - eventTargetDestinations.length}</strong> of <strong>{MAX_STREAMS}</strong> Destinations Available
                </div>
            </header>

            <hr/>

            <div>

                {(streamTargetView.pending === false && !eventTargetDestinations.length) ?
                    <div className="alert alert-info">
                        <h4>No Social LIVE Destinations Assigned</h4>
                        <p>Click the <strong>Add Destination</strong> button and select a new Social LIVE Destination.</p>
                    </div> : null}

                {streamTargetView.pending !== false ?
                    <PendingTarget
                        {...streamTargetView.pending}
                        submit={this.submit}
                        cancel={ev => {
                            ev && ev.preventDefault()
                            this.props.actions.streamTargets.addPending(false)
                        }}>
                        {inputs.map((input, index) =>
                            this.renderPendingTargetInputs(input, index)
                        )}
                        <hr/>
                        <div className="help">
                            <HelpContent/>
                        </div>
                    </PendingTarget> : null}

                {eventTargetDestinations.length ?
                    eventTargetDestinations.map(
                        (destination, index) => <AltDestination
                            key={'destination-' + index}
                            edit={this.toggleTargetEdit}
                            destination={destination}
                            eventStatus={this.props.event.eventStatus}
                            remove={(ev) => {
                                ev && ev.preventDefault()
                                self.setState({
                                    confirmDeleteModal: destination.altEventStreamID
                                })
                            }}
                        />
                    ) : null}
            </div>

            <Modal bsSize="large"
                animation={false}
                show={!!this.state.confirmDeleteModal === true}
                onHide={this.toggleConfirmDelete}>

                <Modal.Header closeButton>
                    <h4>Delete Destination?</h4>
                    <p>This cannot be undone!</p>
                </Modal.Header>

                <Modal.Footer>
                    <button className="btn btn-link" onClick={this.toggleConfirmDelete}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={() => {

                        self.props.actions.streamTargets.delete({
                            eventID: self.props.event.eventID,
                            altEventStreamID: this.state.confirmDeleteModal
                        })

                        this.setState(() => ({
                            confirmDeleteModal: false
                        }))
                    }}>
                        <FaTrashO/> Delete
                    </button>
                </Modal.Footer>

            </Modal>
        </div>
    }

    renderPendingTargetInputs (target, index) {
        let { validators } = this.state

        return <div key={'input-' + index} className={[
            'input-group',
            (validators.indexOf(target.name) > -1) ?
                'has-error' : ''
        ].join(' ')}>
            <span className="input-group-addon">
                <strong>{target.label}</strong>
            </span>
            <input
                ref={target.ref}
                type="text"
                className="form-control"
                placeholder={target.placeholderText}
                defaultValue=""/>
        </div>
    }
}

Wrapper.propTypes = {}

const mapStateToProps = state => {
    const eventTargetDestinations = state.data.eventTargetDestinations
    const isResolving = getHasRequestPending(state, [
        'BUS/http.streamTargets.getAltDestinations',
        'BUS/http.streamTargets.edit',
        'BUS/http.streamTargets.add',
        'BUS/http.streamTargets.delete',
    ])
    return { eventTargetDestinations, isResolving }
}

export default connect(mapStateToProps)(Wrapper)

